import {
  VoteDetailsById,
  VoteLiveDisplay,
  VotingInfoData,
} from '@src/models/voting';
import {api} from './client';
import {Pagination} from '@src/models/pagination';
import {imagesService} from '@src/features/images/logic/images-service';
export namespace votingApi {
  export interface createVoteReq {
    title: string;
    durationTime: number;
    companyId: string;
    eventId?: string;
    order?: number;
  }
  export const createVote = async (body: createVoteReq) => {
    const res = await api.post('votes/new-vote', body);
    return res.data;
  };
  export interface editVoteReq {
    title: string;
    durationTime: number;
    eventId?: string;
    voteId: string;
  }
  export const editVote = async (body: editVoteReq) => {
    const res = await api.put('votes/edit-vote', body);
    return res.data;
  };
  export interface createAddAnswerReq {
    voteId: string;
    title: string;
    description?: string;
  }
  export const addAnswer = async (body: createAddAnswerReq) => {
    const res = await api.post('votes/add-answer', body);
    return res.data;
  };
  export const showVotesListForEvent = async (
    eventId: string,
    params: object
  ) => {
    const res = await api.get<Pagination<VotingInfoData>>(
      'votes/votes-list-for-event/' + eventId,
      params
    );
    return res.data;
  };
  export const getVoteDetailsById = async (voteId: string) => {
    const res = await api.get<VoteDetailsById>('votes/' + voteId);
    return res.data;
  };
  export interface editVoteAnswerReq {
    voteId: string;
    title: string;
    description?: string;
    city?: string;
    answerId: string;
  }
  export const editVoteAnswer = async (body: editVoteAnswerReq) => {
    const res = await api.patch('votes/edit-answer', body);
    return res.data;
  };
  export interface deleteVoteAnswerReq {
    voteId: string;
    answerId: string;
  }
  export const deleteVoteAnswer = async (body: deleteVoteAnswerReq) => {
    const res = await api.delete('votes/delete-answer', {data: body});
    return res.data;
  };
  export const deleteVoting = async (id: string) => {
    const res = await api.patch('votes/delete-vote/' + id);
    return res.data;
  };
  export const startVoting = async (voteId: string) => {
    const res = await api.put('votes/start-vote/' + voteId);
    return res.data;
  };

  export interface VoteForAnswer {
    voteId: string;
    answerId: string;
  }

  export const voteForAnswer = async (body: VoteForAnswer) => {
    const res = await api.put('votes/vote-for-answer', body);
    return res.data;
  };

  export const sendVotingImage = async (formData: FormData) => {
    const res = await api.post('cdn/upload', formData);
    return res.data;
  };
  interface getAllCompanyVotesNotSignedReq {
    page: number;
    limit: number;
    id: string;
    eventId?: string;
  }
  export const getCompanyVotesNotSigned = async (
    body: getAllCompanyVotesNotSignedReq
  ) => {
    const res = await api.get<Pagination<VotingInfoData>>(
      'votes/company/' + body.id,
      {
        params: {
          notSigned: true,
          page: body.page,
          limit: body.limit,
          ...(body.eventId ? {eventId: body.eventId} : {}),
        },
      }
    );
    return res.data;
  };
  interface getAllCompanyVotesReq {
    page: number;
    limit: number;
    isArchived?: boolean;
    isMy?: boolean;
  }
  export const getAllCompanyVotes = async (
    id: string,
    params: getAllCompanyVotesReq
  ) => {
    const res = await api.get<Pagination<VotingInfoData>>(
      'votes/company/' + id,
      {
        params: params,
      }
    );
    return res.data;
  };
  interface getAllVotesAdminReq {
    page: number;
    query: string;
    limit: number;
    isArchived?: boolean;
  }
  export const getAllVotesAdmin = async (params: getAllVotesAdminReq) => {
    const res = await api.get<Pagination<VotingInfoData>>(
      'votes/all/for-admin',
      {
        params: params,
      }
    );
    return res.data;
  };

  export const getVoteLiveDetailsById = async (id: string) => {
    const res = await api.get<VoteLiveDisplay>(`votes/${id}/live-dashboard`);
    return res.data;
  };

  export interface changeVotesOrderReq {
    votes: {id: string; order: number}[];
  }

  export const changeVotesOrder = async (body: changeVotesOrderReq) => {
    const res = await api.put('votes/edit-votes-order', body);
    return res.data;
  };

  export const exportVoteStatisticsPdf = async (body: {
    voteId: string;
    includeVoters?: boolean;
    lang?: string;
  }) => {
    const res = await api.get(`votes/${body.voteId}/statistics/pdf`, {
      responseType: 'blob',
      params: {
        includeVoters: body.includeVoters,
        lang: body.lang,
      },
    });

    if (!res.data) {
      throw new Error('DOWNLOAD_ERROR');
    }
    if (res.data) {
      const name = `${body.voteId}_${new Date().toISOString()}_summary`;
      imagesService.downloadPDFFile(res.data, name + '.pdf');
    }
    return res.data;
  };

  export const exportEventVoteStatisticsPdf = async (body: {
    eventId: string;
    includeVoters?: boolean;
    lang?: string;
  }) => {
    const res = await api.get(`votes/event/${body.eventId}/statistics/pdf`, {
      responseType: 'blob',
      params: {
        includeVoters: body.includeVoters,
        lang: body.lang,
      },
    });

    if (!res.data) {
      throw new Error('DOWNLOAD_ERROR');
    }
    if (res.data) {
      const name = `${body.eventId}_${new Date().toISOString()}_votes_summary`;
      imagesService.downloadPDFFile(res.data, name + '.pdf');
    }
    return res.data;
  };
}
